export const BTN_TYPES = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
};

export const PROMO_END_DATE: Date | null = new Date(
  "2026-07-06T23:59:59-07:00",
);

export const PAYMENT_ERRORS = {
  PAYMENT_FAILED: "There was a problem with your payment.",
  GENERIC_ERROR: "Something went wrong",
  REQUIRED_FIELD_ERROR: "REQUIRED_FIELD_ERROR",
};

export const PRODUCT_KIND = {
  MATIC_ROBOT: "MATIC_ROBOT",
  MATIC_ROBOT_SUBSCRIPTION: "MATIC_ROBOT_SUBSCRIPTION",
};

export const CUSTOM_ERROR_CODES = {
  EXPIRED_CART: "EXPIRED_CART",
  MISMATCHED_CART_PARAMETERS: "MISMATCHED_CART_PARAMETERS",
  CART_CONTENTS_UPDATED: "CART_CONTENTS_UPDATED",
};

export const META_PIXEL_ID = "901116344381948";

export const X_PIXEL_ID = "rc03g";

export const PINTEREST_TAG_ID = "2614139120404";

export const OPENAI_PIXEL_ID = "Dw2DWfFcTkWidxTf2jJsKN";

// The account's public key (its company id), safe to ship to the browser.
export const KLAVIYO_PUBLIC_KEY = "WHvum5";

export const TATARI_TAG_ID = "9b8f97af-6720-4ed1-a425-ed611c1cf78f";

export const PODSCRIBE_USER_ID = "f0281ca0-715d-4e71-8e2d-c81981ffdece";
export const GTM_CONTAINER_ID = "GTM-NDS62MMX";

export const SUBSCRIBED_LOCAL_STORAGE_KEY = "isSubscribed";

export const formatNumber = (number: number | string) => {
  // Use Number.toFixed(2) to round to two decimal places.
  const roundedNumber = parseFloat(String(number)).toFixed(2);

  // Use parseFloat to remove trailing zeros and convert back to a number.
  return parseFloat(roundedNumber);
};

export const VALID_COHORT_KEYS = [
  "new_features",
  "promotions",
  "international_shipping",
] as const;

export type CohortKey = (typeof VALID_COHORT_KEYS)[number];

export const COHORT_LABELS: Record<CohortKey, string> = {
  new_features: "New Features",
  promotions: "Promotions",
  international_shipping: "International Shipping",
};

export const COHORT_SHOPIFY_TAGS: Record<CohortKey, string> = {
  new_features: "subscribed-newfeat",
  promotions: "subscribed-promotions",
  international_shipping: "subscribed-intl",
};

export const SWEEPSTAKES_ANSWER_TAGS = {
  endless_pet_hair: "endless-pet-hair-ss",
  less_kids: "less-kids-ss",
  hate_vacuuming: "hate-vacuuming-ss",
  hate_mopping: "hate-mopping-ss",
  multiple_floors: "multiple-floors-ss",
} as const;

export type SweepstakesAnswerKey = keyof typeof SWEEPSTAKES_ANSWER_TAGS;

export const SWEEPSTAKES_ENTERED_LOCAL_STORAGE_KEY = "sweepstakesEnteredAt";

export const SWEEPSTAKES_DISMISSED_SESSION_STORAGE_KEY = "sweepstakesDismissed";

export const KLAVIYO_EMAIL_CLICK_QUERY_PARAM = "_kx";

const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const validateEmail = (email: string) => {
  const isValid = EMAIL_REGEX.test(email);

  return isValid;
};
